import { logAndNotifyError } from "../modules/logger";
import Notify from "devextreme/ui/notify";

// @import url("../node_modules/ace-builds/css/ace.css");
// @import url("../node_modules/ace-builds/css/theme/dreamweaver.css");
// @import url("../node_modules/ace-builds/css/theme/ambiance.css");
// @import url("../node_modules/devextreme/dist/css/dx.carmine.css");
import { ChangeEventHandler, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { get, getUserInfo, post } from "../modules/server";
import { Alert, Button, Card, Row } from "react-bootstrap";
import { ValueChangedInfo } from "devextreme/ui/editor/editor";
import { EventInfo } from "devextreme/events";
import { DataGrid, List } from "devextreme-react";
import { OptionChangedEventInfo } from "devextreme/core/dom_component";

import ArrayStore from "devextreme/data/array_store";
import dxDataGrid, { EditingStartEvent, NewRowInfo, RowDblClickEvent } from "devextreme/ui/data_grid";
import { Column, Editing, Form, Popup } from "devextreme-react/data-grid";
import { useForm } from "react-hook-form";
import ValidationSummaryMessages from "../components/Configuration/ValidationSummaryMessages";
import TextEditor from "../components/Global/Editors/TextEditor";
import { useNavigate } from "react-router-dom";

const UserForgotPassword = () => {
  const formHook = useForm({ defaultValues: { password: "", confirmPassword: "" } });
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<boolean | undefined>(undefined);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submittingRef = useRef(false); // re-entrancy guard

  const { handleSubmit, formState } = formHook;

  const onCancel = async () => {
    navigate(-1);
  };

  const onGotoLogin = async () => {
    navigate("/login");
  };

  const onSubmit = async (data: any) => {
    if (submittingRef.current) return; // guard against double submits
    submittingRef.current = true;

    try {
      const response = await post("api/Authenticate/RestorePassword", data);

      setMessage(response.message);
      setStatus(response.succeded);
    } catch (ex) {
      logAndNotifyError(ex);
    } finally {
      submittingRef.current = false; //Release guard
    }
  };

  const isBusy = formState.isSubmitting || submittingRef.current;

  return (
    <>
      {status !== true ? (
        <>
          <form onSubmit={handleSubmit(onSubmit)} className="ModuleConfiguratorForm">
            <Card>
              <Card.Header>
                <h3 className="card-title">Återställ lösenord</h3>
              </Card.Header>
              <Card.Body>
                <Alert variant="info">Ange din email-adress nedan för att återställa ditt lösenord</Alert>
                <div className="row ml-0">
                  <div className="col-lg-12">
                    <TextEditor
                      label="Email"
                      fieldName={"email"}
                      formHook={formHook as any}
                      options={{
                        required: "Du måste ange din email-adress",
                      }}
                    ></TextEditor>
                  </div>
                </div>

                {status === false && <Alert variant="danger">{message !== "" ? message : "Ett fel inträffade, försök igen senare eller kontakta supporten."}</Alert>}
              </Card.Body>
              <Card.Footer>
                <div className="module">
                  {/* <button type="button" className="btn btn-info">
                Hjälp
              </button> */}
                </div>
                <div className="footerGroup">
                  <button type="button" className="btn btn-secondary ms-2" onClick={onCancel} disabled={isBusy} aria-busy={isBusy}>
                    Avbryt
                  </button>
                  <button type="submit" className="btn btn-primary ms-2">
                    {isBusy ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <span>Lösenord återställs...</span>
                      </>
                    ) : (
                      <>
                        <span>Skicka</span>
                      </>
                    )}
                  </button>
                </div>
              </Card.Footer>
            </Card>
          </form>
        </>
      ) : (
        <>
          <Card>
            <Card.Header>
              <h3 className="card-title">Återställ lösenord</h3>
            </Card.Header>
            <Card.Body>
              <Alert variant="success">{message}</Alert>
            </Card.Body>
            <Card.Footer>
              <div className="module">
                {/* <button type="button" className="btn btn-info">
                Hjälp
              </button> */}
              </div>
              <div className="footerGroup">
                <button type="button" className="btn btn-primary ms-2" onClick={onGotoLogin}>
                  Logga in
                </button>
              </div>
            </Card.Footer>
          </Card>
        </>
      )}
    </>
  );
};

export default UserForgotPassword;
